module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_1@2x.73c82ff8.png";